import React from 'react';
import { Link } from 'react-router-dom';
import AnimateOnScroll from './AnimateOnScroll.js';

const ServiceCard = ({ title, description, deliverables, imageSrc, altText, imageWidth, imageHeight, imageOnRight }) => {
  return (
    <AnimateOnScroll animation={imageOnRight ? "fade-in-left" : "fade-in-right"}>
      <div className="text-container-blur" style={{ maxWidth: '64rem' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          {/* Image */}
          <div className={imageOnRight ? "order-1 lg:order-2" : "order-1"}>
            <div className="overflow-hidden rounded-lg shadow-md group">
              <img
                src={imageSrc}
                alt={altText}
                className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                width={imageWidth}
                height={imageHeight}
              />
            </div>
          </div>
          {/* Content */}
          <div className={imageOnRight ? "order-2 lg:order-1" : "order-2"}>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">{title}</h2>
            <p className="text-gray-700 text-base mb-4">{description}</p>
            {deliverables && deliverables.length > 0 && (
              <div className="mb-5">
                <p className="text-sm font-bold text-gray-900 mb-2">Key Deliverables:</p>
                <div className="flex flex-col gap-1.5">
                  {deliverables.map((item, i) => (
                    <div key={i} className="flex items-start gap-2">
                      <svg className="w-4 h-4 text-green-700 mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <Link to="/contact" className="cta-button">Request a Quote</Link>
          </div>
        </div>
      </div>
    </AnimateOnScroll>
  );
};

export default ServiceCard;
